<template lang="pug">
  .table-responsive
    table#tbItemsExcel.table.is-striped.is-fullwidth
      thead
        tr
          th.is-size-6
            | #
          th.is-size-6
            | Descripción
          th.is-size-6
            | Cantidad
          th.is-size-6
            | U. Medida
          th.is-size-6
            | P. Unit.
          th.is-size-6
            | Importe
      tfoot
        tr
          th(colspan="5").is-size-6.is-text-right
            | Subtotal
          td
            span.tag
              | {{ requisicion.subtotal | currency }}
        tr
          th(colspan="5").is-size-6.is-text-right
            | I.V.A.
          td
            span.tag.is-dark
              | {{ requisicion.iva | currency }}
        tr
          th(colspan="5").is-size-6.is-text-right
            | Total
          td
            span.tag.is-black
              | {{ requisicion.total | currency }}
      tbody
        tr(v-for="(i, index) in items" :key="i.id")
          td.is-size-6 {{ index + 1 }}
          td.is-size-6 
            span.tag.is-black
              | {{ i.descripcion }}
          td.is-size-6 {{ i.cantidad }}
          td.is-size-6 {{ convertUnidadMedida(i.unidadMedida) }}
          td.is-size-6 {{ i.precioUnitario | currency }}
          td.is-size-6
            b {{ i.importe | currency }}
</template>

<script>
  export default {
    name: 'TablaItemsExcel',
    props: {
      items: {
        type: Array,
        default: []
      },
      requisicion: {
        type: Object,
        default: {}
      },
    },
    methods: {
      convertUnidadMedida (uM) {
        switch (uM) {
          case '1':
            uM = 'Pieza(s)'
            break
          case '2':
            uM = 'Caja(s)'
            break
          case '3':
            uM = 'Estuche(s)'
            break
          case '4':
            uM = 'Juego(s)'
            break
          case '5':
            uM = 'Kit(s)'
            break
          case '6':
            uM = 'Paquete(s)'
            break
          case '7':
            uM = 'Kgr(s)'
            break
          case '8':
            uM = 'Metro(s)'
            break
          case '9':
            uM = 'Galón(es)'
            break
          case '10':
            uM = 'Litro(s)'
            break
          case '11':
            uM = 'Servicio(s)'
            break
          default:
            uM = ''
            break
        }
        return uM
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/TablaItemsExcel.vue